module.exports = __webpack_public_path__ + "media/logos/pymnts-logo-white-testimonial-c1e13e60.png";